<div class="toast toast-{{ toast?.type }}" [style.top.px]="i * 140">
  <h4 class="toast-heading">{{ toast?.title }}</h4>
  <p>{{ toast?.body }}</p>
  <a class="close" (click)="remove.emit(i)">&times;</a>
</div>
